const pickupTypesList = [
  { label: "HOTEL", value: "HOTEL" },
  { label: "PORT", value: "PORT" },
  { label: "AIR PORT", value: "AIRPORT" },
];

export default pickupTypesList;
